export default "__VITE_ASSET__DdPANTm8__"